import React from "react";
import NotificationSystem from "react-notification-system";
import { style as notificationStyling } from "variables/Variables.jsx";

const CustomNotificationSystem = React.forwardRef((props, ref) => (
  <NotificationSystem ref={ref} style={notificationStyling} />
));

export default CustomNotificationSystem;
